/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.3.0.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-fetch-client';
import * as moment from 'moment';
var AuthService = /** @class */ (function () {
    function AuthService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    AuthService.prototype.getUser = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Core/AuthService/GetUser";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetUser(_response);
        });
    };
    AuthService.prototype.processGetUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = UserViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param userName (optional)
     * @param password (optional)
     * @param isPersistent (optional)
     * @param scope (optional)
     * @return Success
     */
    AuthService.prototype.login = function (userName, password, isPersistent, scope) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Core/AuthService/Login?";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (isPersistent !== undefined)
            url_ += "isPersistent=" + encodeURIComponent("" + isPersistent) + "&";
        if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processLogin(_response);
        });
    };
    AuthService.prototype.processLogin = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SignInResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    AuthService.prototype.logout = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Core/AuthService/Logout";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processLogout(_response);
        });
    };
    AuthService.prototype.processLogout = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    AuthService = __decorate([
        inject(String, HttpClient)
    ], AuthService);
    return AuthService;
}());
export { AuthService };
var CompanyFileCategoryService = /** @class */ (function () {
    function CompanyFileCategoryService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    CompanyFileCategoryService.prototype.getAll = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyFileCategoryService/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    CompanyFileCategoryService.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(CompanyFileCategory.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CompanyFileCategoryService.prototype.all = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyFileCategoryService/All";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processAll(_response);
        });
    };
    CompanyFileCategoryService.prototype.processAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(CompanyFileCategory.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param model (optional)
     * @return Success
     */
    CompanyFileCategoryService.prototype.save = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyFileCategoryService/Save";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSave(_response);
        });
    };
    CompanyFileCategoryService.prototype.processSave = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CompanyFileCategory.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CompanyFileCategoryService.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyFileCategoryService/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    CompanyFileCategoryService.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CompanyFileCategory.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    CompanyFileCategoryService = __decorate([
        inject(String, HttpClient)
    ], CompanyFileCategoryService);
    return CompanyFileCategoryService;
}());
export { CompanyFileCategoryService };
var CompanyScoreNoteService = /** @class */ (function () {
    function CompanyScoreNoteService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param companyId (optional)
     * @return Success
     */
    CompanyScoreNoteService.prototype.getByCompany = function (companyId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyScoreNoteService/GetByCompany?";
        if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetByCompany(_response);
        });
    };
    CompanyScoreNoteService.prototype.processGetByCompany = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CompanyScoreNote.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param filter (optional)
     * @param sort (optional)
     * @return Success
     */
    CompanyScoreNoteService.prototype.getAll = function (filter, sort) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyScoreNoteService/GetAll?";
        if (filter !== undefined)
            filter && filter.forEach(function (item, index) {
                for (var attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "Filter[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
                    }
            });
        if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    CompanyScoreNoteService.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(CompanyScoreNote.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CompanyScoreNoteService.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyScoreNoteService/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    CompanyScoreNoteService.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CompanyScoreNote.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param model (optional)
     * @return Success
     */
    CompanyScoreNoteService.prototype.save = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyScoreNoteService/Save";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSave(_response);
        });
    };
    CompanyScoreNoteService.prototype.processSave = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CompanyScoreNote.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CompanyScoreNoteService.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyScoreNoteService/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDelete(_response);
        });
    };
    CompanyScoreNoteService.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    CompanyScoreNoteService = __decorate([
        inject(String, HttpClient)
    ], CompanyScoreNoteService);
    return CompanyScoreNoteService;
}());
export { CompanyScoreNoteService };
var CompanyScoreService = /** @class */ (function () {
    function CompanyScoreService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param companyId (optional)
     * @return Success
     */
    CompanyScoreService.prototype.getScores = function (companyId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyScoreService/GetScores?";
        if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetScores(_response);
        });
    };
    CompanyScoreService.prototype.processGetScores = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(CompanyScore.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param scores (optional)
     * @return Success
     */
    CompanyScoreService.prototype.save = function (id, scores) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyScoreService/Save/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(scores);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSave(_response);
        });
    };
    CompanyScoreService.prototype.processSave = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    CompanyScoreService = __decorate([
        inject(String, HttpClient)
    ], CompanyScoreService);
    return CompanyScoreService;
}());
export { CompanyScoreService };
var CompanyService = /** @class */ (function () {
    function CompanyService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param sort (optional)
     * @return Success
     */
    CompanyService.prototype.getAllVM = function (filter, sort) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/GetAllVM?";
        if (filter !== undefined)
            filter && filter.forEach(function (item, index) {
                for (var attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "Filter[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
                    }
            });
        if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAllVM(_response);
        });
    };
    CompanyService.prototype.processGetAllVM = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(CompanyVM.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param filter (optional)
     * @param sort (optional)
     * @return Success
     */
    CompanyService.prototype.getAllInactive = function (filter, sort) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/GetAllInactive?";
        if (filter !== undefined)
            filter && filter.forEach(function (item, index) {
                for (var attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "Filter[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
                    }
            });
        if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAllInactive(_response);
        });
    };
    CompanyService.prototype.processGetAllInactive = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(CompanyVM.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CompanyService.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    CompanyService.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Company.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CompanyService.prototype.pdf = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/Pdf/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processPdf(_response);
        });
    };
    CompanyService.prototype.processPdf = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CompanyService.prototype.pdf2 = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/Pdf2/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processPdf2(_response);
        });
    };
    CompanyService.prototype.processPdf2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CompanyService.prototype.downloadRapor = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/DownloadRapor?";
        if (id !== undefined)
            id && id.forEach(function (item) { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDownloadRapor(_response);
        });
    };
    CompanyService.prototype.processDownloadRapor = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CompanyService.prototype.downloadFiles = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/DownloadFiles/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDownloadFiles(_response);
        });
    };
    CompanyService.prototype.processDownloadFiles = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param model (optional)
     * @return Success
     */
    CompanyService.prototype.save = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/Save";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSave(_response);
        });
    };
    CompanyService.prototype.processSave = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Company.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CompanyService.prototype.excelWithCols = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/ExcelWithCols?";
        if (id !== undefined)
            id && id.forEach(function (item) { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processExcelWithCols(_response);
        });
    };
    CompanyService.prototype.processExcelWithCols = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CompanyService.prototype.excel = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/Excel?";
        if (id !== undefined)
            id && id.forEach(function (item) { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processExcel(_response);
        });
    };
    CompanyService.prototype.processExcel = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @param status (optional)
     * @return Success
     */
    CompanyService.prototype.setStatus = function (id, status) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/SetStatus?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSetStatus(_response);
        });
    };
    CompanyService.prototype.processSetStatus = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @param tahsisId (optional)
     * @return Success
     */
    CompanyService.prototype.setTahsisSonuc = function (id, tahsisId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/SetTahsisSonuc?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (tahsisId !== undefined)
            url_ += "TahsisId=" + encodeURIComponent("" + tahsisId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSetTahsisSonuc(_response);
        });
    };
    CompanyService.prototype.processSetTahsisSonuc = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CompanyService.prototype.setBasariSirasi = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/SetBasariSirasi";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSetBasariSirasi(_response);
        });
    };
    CompanyService.prototype.processSetBasariSirasi = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @param email (optional)
     * @return Success
     */
    CompanyService.prototype.changeEmail = function (id, email) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/ChangeEmail?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processChangeEmail(_response);
        });
    };
    CompanyService.prototype.processChangeEmail = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @param message (optional)
     * @return Success
     */
    CompanyService.prototype.guncellemeyeGonder = function (id, message) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/GuncellemeyeGonder?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (message !== undefined)
            url_ += "Message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGuncellemeyeGonder(_response);
        });
    };
    CompanyService.prototype.processGuncellemeyeGonder = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param email (optional)
     * @return Success
     */
    CompanyService.prototype.sendLink = function (email) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/SendLink?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSendLink(_response);
        });
    };
    CompanyService.prototype.processSendLink = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CompanySendLinkVM.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CompanyService.prototype.sendLinkMail = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/SendLinkMail?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSendLinkMail(_response);
        });
    };
    CompanyService.prototype.processSendLinkMail = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param companyId (optional)
     * @param file (optional)
     * @return Success
     */
    CompanyService.prototype.fileUpload = function (companyId, file) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/FileUpload?";
        if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (file !== undefined)
            url_ += "file=" + encodeURIComponent("" + file) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processFileUpload(_response);
        });
    };
    CompanyService.prototype.processFileUpload = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CompanyFile.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param companyId (optional)
     * @param fileId (optional)
     * @return Success
     */
    CompanyService.prototype.fileRemove = function (companyId, fileId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/FileRemove?";
        if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processFileRemove(_response);
        });
    };
    CompanyService.prototype.processFileRemove = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param filter (optional)
     * @param sort (optional)
     * @return Success
     */
    CompanyService.prototype.getAll = function (filter, sort) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/GetAll?";
        if (filter !== undefined)
            filter && filter.forEach(function (item, index) {
                for (var attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "Filter[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
                    }
            });
        if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    CompanyService.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                        var item = resultData200_7[_i];
                        result200.push(Company.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CompanyService.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/CompanyService/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDelete(_response);
        });
    };
    CompanyService.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    CompanyService = __decorate([
        inject(String, HttpClient)
    ], CompanyService);
    return CompanyService;
}());
export { CompanyService };
var ConstantService = /** @class */ (function () {
    function ConstantService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param sort (optional)
     * @return Success
     */
    ConstantService.prototype.getAll = function (filter, sort) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Core/ConstantService/GetAll?";
        if (filter !== undefined)
            filter && filter.forEach(function (item, index) {
                for (var attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "Filter[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
                    }
            });
        if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    ConstantService.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                        var item = resultData200_8[_i];
                        result200.push(Constant.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param group (optional)
     * @return Success
     */
    ConstantService.prototype.getConstants = function (group) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Core/ConstantService/GetConstants?";
        if (group !== undefined)
            url_ += "group=" + encodeURIComponent("" + group) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetConstants(_response);
        });
    };
    ConstantService.prototype.processGetConstants = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                        var item = resultData200_9[_i];
                        result200.push(Constant.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ConstantService.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Core/ConstantService/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    ConstantService.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Constant.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param model (optional)
     * @return Success
     */
    ConstantService.prototype.save = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Core/ConstantService/Save";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSave(_response);
        });
    };
    ConstantService.prototype.processSave = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Constant.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ConstantService.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Core/ConstantService/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDelete(_response);
        });
    };
    ConstantService.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ConstantService = __decorate([
        inject(String, HttpClient)
    ], ConstantService);
    return ConstantService;
}());
export { ConstantService };
var GuestCompanyService = /** @class */ (function () {
    function GuestCompanyService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param email (optional)
     * @param token (optional)
     * @return Success
     */
    GuestCompanyService.prototype.get = function (email, token) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Guest/GuestCompanyService/Get?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    GuestCompanyService.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Company.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param email (optional)
     * @param token (optional)
     * @return Success
     */
    GuestCompanyService.prototype.taahhutname = function (email, token) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Guest/GuestCompanyService/Taahhutname?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processTaahhutname(_response);
        });
    };
    GuestCompanyService.prototype.processTaahhutname = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @param token (optional)
     * @return Success
     */
    GuestCompanyService.prototype.pdf = function (id, token) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Guest/GuestCompanyService/Pdf?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processPdf(_response);
        });
    };
    GuestCompanyService.prototype.processPdf = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @param token (optional)
     * @return Success
     */
    GuestCompanyService.prototype.pdf2 = function (id, token) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Guest/GuestCompanyService/Pdf2?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processPdf2(_response);
        });
    };
    GuestCompanyService.prototype.processPdf2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param email (optional)
     * @param token (optional)
     * @return Success
     */
    GuestCompanyService.prototype.basvur = function (email, token) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Guest/GuestCompanyService/Basvur?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processBasvur(_response);
        });
    };
    GuestCompanyService.prototype.processBasvur = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param email (optional)
     * @param token (optional)
     * @param model (optional)
     * @return Success
     */
    GuestCompanyService.prototype.save = function (email, token, model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Guest/GuestCompanyService/Save?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSave(_response);
        });
    };
    GuestCompanyService.prototype.processSave = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Company.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param companyId (optional)
     * @param categoryId (optional)
     * @param file (optional)
     * @return Success
     */
    GuestCompanyService.prototype.fileUpload = function (companyId, categoryId, file) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Guest/GuestCompanyService/FileUpload?";
        if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (file !== undefined)
            url_ += "file=" + encodeURIComponent("" + file) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processFileUpload(_response);
        });
    };
    GuestCompanyService.prototype.processFileUpload = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CompanyFile.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param email (optional)
     * @param token (optional)
     * @param fileId (optional)
     * @param name (optional)
     * @return Success
     */
    GuestCompanyService.prototype.fileRename = function (email, token, fileId, name) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Guest/GuestCompanyService/FileRename?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processFileRename(_response);
        });
    };
    GuestCompanyService.prototype.processFileRename = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param email (optional)
     * @param token (optional)
     * @param fileId (optional)
     * @return Success
     */
    GuestCompanyService.prototype.fileRemove = function (email, token, fileId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Guest/GuestCompanyService/FileRemove?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processFileRemove(_response);
        });
    };
    GuestCompanyService.prototype.processFileRemove = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    GuestCompanyService = __decorate([
        inject(String, HttpClient)
    ], GuestCompanyService);
    return GuestCompanyService;
}());
export { GuestCompanyService };
var ProjectService = /** @class */ (function () {
    function ProjectService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param sort (optional)
     * @return Success
     */
    ProjectService.prototype.getAll = function (filter, sort) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Projects/ProjectService/GetAll?";
        if (filter !== undefined)
            filter && filter.forEach(function (item, index) {
                for (var attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "Filter[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
                    }
            });
        if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    ProjectService.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                        var item = resultData200_10[_i];
                        result200.push(Project.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ProjectService.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Projects/ProjectService/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    ProjectService.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Project.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param model (optional)
     * @return Success
     */
    ProjectService.prototype.save = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Projects/ProjectService/Save";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSave(_response);
        });
    };
    ProjectService.prototype.processSave = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Project.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ProjectService.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Projects/ProjectService/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDelete(_response);
        });
    };
    ProjectService.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ProjectService = __decorate([
        inject(String, HttpClient)
    ], ProjectService);
    return ProjectService;
}());
export { ProjectService };
var ReportService = /** @class */ (function () {
    function ReportService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    ReportService.prototype.dashboard = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/ReportService/Dashboard";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDashboard(_response);
        });
    };
    ReportService.prototype.processDashboard = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DashboardVM.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ReportService = __decorate([
        inject(String, HttpClient)
    ], ReportService);
    return ReportService;
}());
export { ReportService };
var RoleService = /** @class */ (function () {
    function RoleService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    RoleService.prototype.getAll = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/RoleService/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    RoleService.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_11 = resultData200; _i < resultData200_11.length; _i++) {
                        var item = resultData200_11[_i];
                        result200.push(Role.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    RoleService = __decorate([
        inject(String, HttpClient)
    ], RoleService);
    return RoleService;
}());
export { RoleService };
var ScoreService = /** @class */ (function () {
    function ScoreService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param sort (optional)
     * @return Success
     */
    ScoreService.prototype.getAll = function (filter, sort) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/ScoreService/GetAll?";
        if (filter !== undefined)
            filter && filter.forEach(function (item, index) {
                for (var attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "Filter[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
                    }
            });
        if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    ScoreService.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_12 = resultData200; _i < resultData200_12.length; _i++) {
                        var item = resultData200_12[_i];
                        result200.push(Score.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param model (optional)
     * @return Success
     */
    ScoreService.prototype.save = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/ScoreService/Save";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSave(_response);
        });
    };
    ScoreService.prototype.processSave = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Score.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ScoreService.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/ScoreService/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    ScoreService.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Score.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ScoreService.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Common/ScoreService/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDelete(_response);
        });
    };
    ScoreService.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    ScoreService = __decorate([
        inject(String, HttpClient)
    ], ScoreService);
    return ScoreService;
}());
export { ScoreService };
var SettingService = /** @class */ (function () {
    function SettingService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param sort (optional)
     * @return Success
     */
    SettingService.prototype.getAll = function (filter, sort) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Core/SettingService/GetAll?";
        if (filter !== undefined)
            filter && filter.forEach(function (item, index) {
                for (var attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "Filter[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
                    }
            });
        if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    SettingService.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_13 = resultData200; _i < resultData200_13.length; _i++) {
                        var item = resultData200_13[_i];
                        result200.push(Setting.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    SettingService.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Core/SettingService/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    SettingService.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Setting.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param model (optional)
     * @return Success
     */
    SettingService.prototype.save = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Core/SettingService/Save";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSave(_response);
        });
    };
    SettingService.prototype.processSave = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Setting.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    SettingService.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Core/SettingService/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDelete(_response);
        });
    };
    SettingService.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    SettingService = __decorate([
        inject(String, HttpClient)
    ], SettingService);
    return SettingService;
}());
export { SettingService };
var UserService = /** @class */ (function () {
    function UserService(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    UserService.prototype.getAll = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/UserService/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAll(_response);
        });
    };
    UserService.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_14 = resultData200; _i < resultData200_14.length; _i++) {
                        var item = resultData200_14[_i];
                        result200.push(UserViewModel.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    UserService.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/UserService/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    UserService.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = UserViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    UserService.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/UserService/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDelete(_response);
        });
    };
    UserService.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param model (optional)
     * @param newPassword (optional)
     * @return Success
     */
    UserService.prototype.changePassword = function (model, newPassword) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/UserService/ChangePassword?";
        if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processChangePassword(_response);
        });
    };
    UserService.prototype.processChangePassword = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param name (optional)
     * @param phoneNumber (optional)
     * @param oldPassword (optional)
     * @param password (optional)
     * @return Success
     */
    UserService.prototype.updateProfile = function (name, phoneNumber, oldPassword, password) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/UserService/UpdateProfile?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (oldPassword !== undefined)
            url_ += "oldPassword=" + encodeURIComponent("" + oldPassword) + "&";
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processUpdateProfile(_response);
        });
    };
    UserService.prototype.processUpdateProfile = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param model (optional)
     * @param password (optional)
     * @return Success
     */
    UserService.prototype.save = function (model, password) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/UserService/Save?";
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSave(_response);
        });
    };
    UserService.prototype.processSave = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = UserViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    UserService = __decorate([
        inject(String, HttpClient)
    ], UserService);
    return UserService;
}());
export { UserService };
var UserViewModel = /** @class */ (function () {
    function UserViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserViewModel.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (var _i = 0, _a = _data["roles"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.roles.push(item);
                }
            }
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? moment.parseZone(_data["lockoutEnd"].toString()) : undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    };
    UserViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserViewModel();
        result.init(data);
        return result;
    };
    UserViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (var _i = 0, _a = this.roles; _i < _a.length; _i++) {
                var item = _a[_i];
                data["roles"].push(item);
            }
        }
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString(true) : undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    };
    UserViewModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UserViewModel();
        result.init(json);
        return result;
    };
    return UserViewModel;
}());
export { UserViewModel };
var SignInResult = /** @class */ (function () {
    function SignInResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SignInResult.prototype.init = function (_data) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.isLockedOut = _data["isLockedOut"];
            this.isNotAllowed = _data["isNotAllowed"];
            this.requiresTwoFactor = _data["requiresTwoFactor"];
        }
    };
    SignInResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SignInResult();
        result.init(data);
        return result;
    };
    SignInResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["isLockedOut"] = this.isLockedOut;
        data["isNotAllowed"] = this.isNotAllowed;
        data["requiresTwoFactor"] = this.requiresTwoFactor;
        return data;
    };
    SignInResult.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SignInResult();
        result.init(json);
        return result;
    };
    return SignInResult;
}());
export { SignInResult };
var CompanyFileCategory = /** @class */ (function () {
    function CompanyFileCategory(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyFileCategory.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.isRequired = _data["isRequired"];
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.updatedOn = _data["updatedOn"] ? moment.parseZone(_data["updatedOn"].toString()) : undefined;
        }
    };
    CompanyFileCategory.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompanyFileCategory();
        result.init(data);
        return result;
    };
    CompanyFileCategory.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["isRequired"] = this.isRequired;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString(true) : undefined;
        return data;
    };
    CompanyFileCategory.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CompanyFileCategory();
        result.init(json);
        return result;
    };
    return CompanyFileCategory;
}());
export { CompanyFileCategory };
var CompanyScoreNote = /** @class */ (function () {
    function CompanyScoreNote(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyScoreNote.prototype.init = function (_data) {
        if (_data) {
            this.projeOzeti = _data["projeOzeti"];
            this.degerlendirmeNotlari = _data["degerlendirmeNotlari"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined;
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.updatedOn = _data["updatedOn"] ? moment.parseZone(_data["updatedOn"].toString()) : undefined;
        }
    };
    CompanyScoreNote.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompanyScoreNote();
        result.init(data);
        return result;
    };
    CompanyScoreNote.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["projeOzeti"] = this.projeOzeti;
        data["degerlendirmeNotlari"] = this.degerlendirmeNotlari;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString(true) : undefined;
        return data;
    };
    CompanyScoreNote.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CompanyScoreNote();
        result.init(json);
        return result;
    };
    return CompanyScoreNote;
}());
export { CompanyScoreNote };
var Company = /** @class */ (function () {
    function Company(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Company.prototype.init = function (_data) {
        if (_data) {
            this.status = _data["status"];
            this.token = _data["token"];
            this.isIndividual = _data["isIndividual"];
            this.name = _data["name"];
            this.adSoyad = _data["adSoyad"];
            this.tcKimlikNo = _data["tcKimlikNo"];
            this.adres = _data["adres"];
            this.sehir = _data["sehir"];
            this.email = _data["email"];
            this.telefon = _data["telefon"];
            this.fax = _data["fax"];
            this.web = _data["web"];
            this.ticaretSicilNo = _data["ticaretSicilNo"];
            this.ticaretOdasi = _data["ticaretOdasi"];
            this.vergiNumarasi = _data["vergiNumarasi"];
            this.vergiDairesi = _data["vergiDairesi"];
            this.sgkSicilNo = _data["sgkSicilNo"];
            this.kayitliSermaye = _data["kayitliSermaye"];
            this.odenmisSermaye = _data["odenmisSermaye"];
            this.kurulusTarihi = _data["kurulusTarihi"];
            this.yatirimTesvikBelgesiNo = _data["yatirimTesvikBelgesiNo"];
            this.mevcutFaaliyetGosterdigiYer = _data["mevcutFaaliyetGosterdigiYer"];
            this.mevcutAcikAlan = _data["mevcutAcikAlan"];
            this.mevcutKapaliAlan = _data["mevcutKapaliAlan"];
            this.yatiriminSektoruVeKonusu = _data["yatiriminSektoruVeKonusu"];
            this.yatiriminCinsi = _data["yatiriminCinsi"];
            this.uretilecekUrunler = _data["uretilecekUrunler"];
            this.ongorulenYatirimBaslangicTarihi = _data["ongorulenYatirimBaslangicTarihi"];
            this.ongorulenYatirimBitisTarihi = _data["ongorulenYatirimBitisTarihi"];
            this.ongorulenIsletmeyeGecisTarihi = _data["ongorulenIsletmeyeGecisTarihi"];
            this.ongorulenIstihdamSayisiMavi = _data["ongorulenIstihdamSayisiMavi"];
            this.ongorulenIstihdamSayisiBeyaz = _data["ongorulenIstihdamSayisiBeyaz"];
            this.sabitYatirimTutariMakine = _data["sabitYatirimTutariMakine"];
            this.sabitYatirimTutariBina = _data["sabitYatirimTutariBina"];
            this.sabitYatirimTutariOz = _data["sabitYatirimTutariOz"];
            this.sabitYatirimTutariKredi = _data["sabitYatirimTutariKredi"];
            this.sabitYatirimTutariToplam = _data["sabitYatirimTutariToplam"];
            this.talepEdilenToplamAlan = _data["talepEdilenToplamAlan"];
            this.planlananKapaliAlan = _data["planlananKapaliAlan"];
            this.projeOzeti = _data["projeOzeti"];
            this.degerlendirmeNotlari = _data["degerlendirmeNotlari"];
            this.ziyaretNotlari = _data["ziyaretNotlari"];
            this.tahsisSonuc = _data["tahsisSonuc"];
            this.basvuruSonuc = _data["basvuruSonuc"];
            this.basariPuani = _data["basariPuani"];
            this.basariSirasi = _data["basariSirasi"];
            this.basvuruNo = _data["basvuruNo"];
            this.nihaiRaporTarihi = _data["nihaiRaporTarihi"] ? moment.parseZone(_data["nihaiRaporTarihi"].toString()) : undefined;
            this.basvuruTarihi = _data["basvuruTarihi"] ? moment.parseZone(_data["basvuruTarihi"].toString()) : undefined;
            if (_data["metaDefinitions"]) {
                this.metaDefinitions = {};
                for (var key in _data["metaDefinitions"]) {
                    if (_data["metaDefinitions"].hasOwnProperty(key))
                        this.metaDefinitions[key] = _data["metaDefinitions"][key] !== undefined ? _data["metaDefinitions"][key] : {};
                }
            }
            if (Array.isArray(_data["years"])) {
                this.years = [];
                for (var _i = 0, _a = _data["years"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.years.push(item);
                }
            }
            if (_data["metas"]) {
                this.metas = {};
                for (var key in _data["metas"]) {
                    if (_data["metas"].hasOwnProperty(key))
                        this.metas[key] = _data["metas"][key] !== undefined ? _data["metas"][key] : {};
                }
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [];
                for (var _b = 0, _c = _data["contacts"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.contacts.push(CompanyContact.fromJS(item));
                }
            }
            if (Array.isArray(_data["files"])) {
                this.files = [];
                for (var _d = 0, _e = _data["files"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.files.push(CompanyFile.fromJS(item));
                }
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [];
                for (var _f = 0, _g = _data["notes"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.notes.push(CompanyScoreNote.fromJS(item));
                }
            }
            if (Array.isArray(_data["scores"])) {
                this.scores = [];
                for (var _h = 0, _j = _data["scores"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.scores.push(CompanyScore.fromJS(item));
                }
            }
            if (Array.isArray(_data["partners"])) {
                this.partners = [];
                for (var _k = 0, _l = _data["partners"]; _k < _l.length; _k++) {
                    var item = _l[_k];
                    this.partners.push(CompanyPartner.fromJS(item));
                }
            }
            this.puanlayanKisiSayisi = _data["puanlayanKisiSayisi"];
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.updatedOn = _data["updatedOn"] ? moment.parseZone(_data["updatedOn"].toString()) : undefined;
        }
    };
    Company.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Company();
        result.init(data);
        return result;
    };
    Company.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["token"] = this.token;
        data["isIndividual"] = this.isIndividual;
        data["name"] = this.name;
        data["adSoyad"] = this.adSoyad;
        data["tcKimlikNo"] = this.tcKimlikNo;
        data["adres"] = this.adres;
        data["sehir"] = this.sehir;
        data["email"] = this.email;
        data["telefon"] = this.telefon;
        data["fax"] = this.fax;
        data["web"] = this.web;
        data["ticaretSicilNo"] = this.ticaretSicilNo;
        data["ticaretOdasi"] = this.ticaretOdasi;
        data["vergiNumarasi"] = this.vergiNumarasi;
        data["vergiDairesi"] = this.vergiDairesi;
        data["sgkSicilNo"] = this.sgkSicilNo;
        data["kayitliSermaye"] = this.kayitliSermaye;
        data["odenmisSermaye"] = this.odenmisSermaye;
        data["kurulusTarihi"] = this.kurulusTarihi;
        data["yatirimTesvikBelgesiNo"] = this.yatirimTesvikBelgesiNo;
        data["mevcutFaaliyetGosterdigiYer"] = this.mevcutFaaliyetGosterdigiYer;
        data["mevcutAcikAlan"] = this.mevcutAcikAlan;
        data["mevcutKapaliAlan"] = this.mevcutKapaliAlan;
        data["yatiriminSektoruVeKonusu"] = this.yatiriminSektoruVeKonusu;
        data["yatiriminCinsi"] = this.yatiriminCinsi;
        data["uretilecekUrunler"] = this.uretilecekUrunler;
        data["ongorulenYatirimBaslangicTarihi"] = this.ongorulenYatirimBaslangicTarihi;
        data["ongorulenYatirimBitisTarihi"] = this.ongorulenYatirimBitisTarihi;
        data["ongorulenIsletmeyeGecisTarihi"] = this.ongorulenIsletmeyeGecisTarihi;
        data["ongorulenIstihdamSayisiMavi"] = this.ongorulenIstihdamSayisiMavi;
        data["ongorulenIstihdamSayisiBeyaz"] = this.ongorulenIstihdamSayisiBeyaz;
        data["sabitYatirimTutariMakine"] = this.sabitYatirimTutariMakine;
        data["sabitYatirimTutariBina"] = this.sabitYatirimTutariBina;
        data["sabitYatirimTutariOz"] = this.sabitYatirimTutariOz;
        data["sabitYatirimTutariKredi"] = this.sabitYatirimTutariKredi;
        data["sabitYatirimTutariToplam"] = this.sabitYatirimTutariToplam;
        data["talepEdilenToplamAlan"] = this.talepEdilenToplamAlan;
        data["planlananKapaliAlan"] = this.planlananKapaliAlan;
        data["projeOzeti"] = this.projeOzeti;
        data["degerlendirmeNotlari"] = this.degerlendirmeNotlari;
        data["ziyaretNotlari"] = this.ziyaretNotlari;
        data["tahsisSonuc"] = this.tahsisSonuc;
        data["basvuruSonuc"] = this.basvuruSonuc;
        data["basariPuani"] = this.basariPuani;
        data["basariSirasi"] = this.basariSirasi;
        data["basvuruNo"] = this.basvuruNo;
        data["nihaiRaporTarihi"] = this.nihaiRaporTarihi ? this.nihaiRaporTarihi.toISOString(true) : undefined;
        data["basvuruTarihi"] = this.basvuruTarihi ? this.basvuruTarihi.toISOString(true) : undefined;
        if (this.metaDefinitions) {
            data["metaDefinitions"] = {};
            for (var key in this.metaDefinitions) {
                if (this.metaDefinitions.hasOwnProperty(key))
                    data["metaDefinitions"][key] = this.metaDefinitions[key];
            }
        }
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (var _i = 0, _a = this.years; _i < _a.length; _i++) {
                var item = _a[_i];
                data["years"].push(item);
            }
        }
        if (this.metas) {
            data["metas"] = {};
            for (var key in this.metas) {
                if (this.metas.hasOwnProperty(key))
                    data["metas"][key] = this.metas[key];
            }
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (var _b = 0, _c = this.contacts; _b < _c.length; _b++) {
                var item = _c[_b];
                data["contacts"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (var _d = 0, _e = this.files; _d < _e.length; _d++) {
                var item = _e[_d];
                data["files"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (var _f = 0, _g = this.notes; _f < _g.length; _f++) {
                var item = _g[_f];
                data["notes"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.scores)) {
            data["scores"] = [];
            for (var _h = 0, _j = this.scores; _h < _j.length; _h++) {
                var item = _j[_h];
                data["scores"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (var _k = 0, _l = this.partners; _k < _l.length; _k++) {
                var item = _l[_k];
                data["partners"].push(item.toJSON());
            }
        }
        data["puanlayanKisiSayisi"] = this.puanlayanKisiSayisi;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString(true) : undefined;
        return data;
    };
    Company.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Company();
        result.init(json);
        return result;
    };
    return Company;
}());
export { Company };
var User = /** @class */ (function () {
    function User(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    User.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? moment.parseZone(_data["lockoutEnd"].toString()) : undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    };
    User.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new User();
        result.init(data);
        return result;
    };
    User.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString(true) : undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    };
    User.prototype.clone = function () {
        var json = this.toJSON();
        var result = new User();
        result.init(json);
        return result;
    };
    return User;
}());
export { User };
var CompanyContact = /** @class */ (function () {
    function CompanyContact(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyContact.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.telefonCep = _data["telefonCep"];
            this.telefon = _data["telefon"];
            this.gorev = _data["gorev"];
            this.adres = _data["adres"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.updatedOn = _data["updatedOn"] ? moment.parseZone(_data["updatedOn"].toString()) : undefined;
        }
    };
    CompanyContact.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompanyContact();
        result.init(data);
        return result;
    };
    CompanyContact.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["telefonCep"] = this.telefonCep;
        data["telefon"] = this.telefon;
        data["gorev"] = this.gorev;
        data["adres"] = this.adres;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString(true) : undefined;
        return data;
    };
    CompanyContact.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CompanyContact();
        result.init(json);
        return result;
    };
    return CompanyContact;
}());
export { CompanyContact };
var CompanyFile = /** @class */ (function () {
    function CompanyFile(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyFile.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.length = _data["length"];
            this.extension = _data["extension"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"] ? CompanyFileCategory.fromJS(_data["category"]) : undefined;
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.updatedOn = _data["updatedOn"] ? moment.parseZone(_data["updatedOn"].toString()) : undefined;
        }
    };
    CompanyFile.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompanyFile();
        result.init(data);
        return result;
    };
    CompanyFile.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["length"] = this.length;
        data["extension"] = this.extension;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : undefined;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString(true) : undefined;
        return data;
    };
    CompanyFile.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CompanyFile();
        result.init(json);
        return result;
    };
    return CompanyFile;
}());
export { CompanyFile };
var CompanyScore = /** @class */ (function () {
    function CompanyScore(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyScore.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
            this.scoreId = _data["scoreId"];
            this.score = _data["score"] ? Score.fromJS(_data["score"]) : undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined;
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.updatedOn = _data["updatedOn"] ? moment.parseZone(_data["updatedOn"].toString()) : undefined;
        }
    };
    CompanyScore.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompanyScore();
        result.init(data);
        return result;
    };
    CompanyScore.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["scoreId"] = this.scoreId;
        data["score"] = this.score ? this.score.toJSON() : undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString(true) : undefined;
        return data;
    };
    CompanyScore.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CompanyScore();
        result.init(json);
        return result;
    };
    return CompanyScore;
}());
export { CompanyScore };
var CompanyPartner = /** @class */ (function () {
    function CompanyPartner(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyPartner.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.ticaretSicilNo = _data["ticaretSicilNo"];
            this.vergiNumarasi = _data["vergiNumarasi"];
            this.vergiDairesi = _data["vergiDairesi"];
            this.uyruk = _data["uyruk"];
            this.hisseOrani = _data["hisseOrani"];
            this.hisseTutari = _data["hisseTutari"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : undefined;
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.updatedOn = _data["updatedOn"] ? moment.parseZone(_data["updatedOn"].toString()) : undefined;
        }
    };
    CompanyPartner.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompanyPartner();
        result.init(data);
        return result;
    };
    CompanyPartner.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ticaretSicilNo"] = this.ticaretSicilNo;
        data["vergiNumarasi"] = this.vergiNumarasi;
        data["vergiDairesi"] = this.vergiDairesi;
        data["uyruk"] = this.uyruk;
        data["hisseOrani"] = this.hisseOrani;
        data["hisseTutari"] = this.hisseTutari;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString(true) : undefined;
        return data;
    };
    CompanyPartner.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CompanyPartner();
        result.init(json);
        return result;
    };
    return CompanyPartner;
}());
export { CompanyPartner };
var Score = /** @class */ (function () {
    function Score(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Score.prototype.init = function (_data) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.multiplier = _data["multiplier"];
            this.order = _data["order"];
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.updatedOn = _data["updatedOn"] ? moment.parseZone(_data["updatedOn"].toString()) : undefined;
        }
    };
    Score.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Score();
        result.init(data);
        return result;
    };
    Score.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["description"] = this.description;
        data["multiplier"] = this.multiplier;
        data["order"] = this.order;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString(true) : undefined;
        return data;
    };
    Score.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Score();
        result.init(json);
        return result;
    };
    return Score;
}());
export { Score };
var Filter = /** @class */ (function () {
    function Filter(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Filter.prototype.init = function (_data) {
        if (_data) {
            this.operator = _data["operator"];
            this.property = _data["property"];
            this.value = _data["value"];
        }
    };
    Filter.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Filter();
        result.init(data);
        return result;
    };
    Filter.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator;
        data["property"] = this.property;
        data["value"] = this.value;
        return data;
    };
    Filter.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Filter();
        result.init(json);
        return result;
    };
    return Filter;
}());
export { Filter };
var CompanyVM = /** @class */ (function () {
    function CompanyVM(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyVM.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.basvuruNo = _data["basvuruNo"];
            this.name = _data["name"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.basvuruTarihi = _data["basvuruTarihi"] ? moment.parseZone(_data["basvuruTarihi"].toString()) : undefined;
            this.status = _data["status"];
            this.basariPuani = _data["basariPuani"];
            this.basariSirasi = _data["basariSirasi"];
            this.basvuruSonuc = _data["basvuruSonuc"];
            this.tahsisSonuc = _data["tahsisSonuc"];
            this.puanlayanKisiSayisi = _data["puanlayanKisiSayisi"];
            this.nihaiRaporTarihi = _data["nihaiRaporTarihi"] ? moment.parseZone(_data["nihaiRaporTarihi"].toString()) : undefined;
            this.yatiriminSektoruVeKonusu = _data["yatiriminSektoruVeKonusu"];
        }
    };
    CompanyVM.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompanyVM();
        result.init(data);
        return result;
    };
    CompanyVM.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["basvuruNo"] = this.basvuruNo;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["basvuruTarihi"] = this.basvuruTarihi ? this.basvuruTarihi.toISOString(true) : undefined;
        data["status"] = this.status;
        data["basariPuani"] = this.basariPuani;
        data["basariSirasi"] = this.basariSirasi;
        data["basvuruSonuc"] = this.basvuruSonuc;
        data["tahsisSonuc"] = this.tahsisSonuc;
        data["puanlayanKisiSayisi"] = this.puanlayanKisiSayisi;
        data["nihaiRaporTarihi"] = this.nihaiRaporTarihi ? this.nihaiRaporTarihi.toISOString(true) : undefined;
        data["yatiriminSektoruVeKonusu"] = this.yatiriminSektoruVeKonusu;
        return data;
    };
    CompanyVM.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CompanyVM();
        result.init(json);
        return result;
    };
    return CompanyVM;
}());
export { CompanyVM };
var CompanySendLinkVM = /** @class */ (function () {
    function CompanySendLinkVM(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanySendLinkVM.prototype.init = function (_data) {
        if (_data) {
            this.isNew = _data["isNew"];
            this.model = _data["model"] ? Company.fromJS(_data["model"]) : undefined;
        }
    };
    CompanySendLinkVM.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompanySendLinkVM();
        result.init(data);
        return result;
    };
    CompanySendLinkVM.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isNew"] = this.isNew;
        data["model"] = this.model ? this.model.toJSON() : undefined;
        return data;
    };
    CompanySendLinkVM.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CompanySendLinkVM();
        result.init(json);
        return result;
    };
    return CompanySendLinkVM;
}());
export { CompanySendLinkVM };
var IFormFile = /** @class */ (function () {
    function IFormFile(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IFormFile.prototype.init = function (_data) {
        if (_data) {
            this.contentType = _data["contentType"];
            this.contentDisposition = _data["contentDisposition"];
            if (_data["headers"]) {
                this.headers = {};
                for (var key in _data["headers"]) {
                    if (_data["headers"].hasOwnProperty(key))
                        this.headers[key] = _data["headers"][key] !== undefined ? _data["headers"][key] : [];
                }
            }
            this.length = _data["length"];
            this.name = _data["name"];
            this.fileName = _data["fileName"];
        }
    };
    IFormFile.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IFormFile();
        result.init(data);
        return result;
    };
    IFormFile.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["contentDisposition"] = this.contentDisposition;
        if (this.headers) {
            data["headers"] = {};
            for (var key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    data["headers"][key] = this.headers[key];
            }
        }
        data["length"] = this.length;
        data["name"] = this.name;
        data["fileName"] = this.fileName;
        return data;
    };
    IFormFile.prototype.clone = function () {
        var json = this.toJSON();
        var result = new IFormFile();
        result.init(json);
        return result;
    };
    return IFormFile;
}());
export { IFormFile };
var Constant = /** @class */ (function () {
    function Constant(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Constant.prototype.init = function (_data) {
        if (_data) {
            this.group = _data["group"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.order = _data["order"];
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.updatedOn = _data["updatedOn"] ? moment.parseZone(_data["updatedOn"].toString()) : undefined;
        }
    };
    Constant.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Constant();
        result.init(data);
        return result;
    };
    Constant.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["order"] = this.order;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString(true) : undefined;
        return data;
    };
    Constant.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Constant();
        result.init(json);
        return result;
    };
    return Constant;
}());
export { Constant };
var Project = /** @class */ (function () {
    function Project(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Project.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.updatedOn = _data["updatedOn"] ? moment.parseZone(_data["updatedOn"].toString()) : undefined;
        }
    };
    Project.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Project();
        result.init(data);
        return result;
    };
    Project.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString(true) : undefined;
        return data;
    };
    Project.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Project();
        result.init(json);
        return result;
    };
    return Project;
}());
export { Project };
var DashboardVM = /** @class */ (function () {
    function DashboardVM(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DashboardVM.prototype.init = function (_data) {
        if (_data) {
            this.sehirRaporu = _data["sehirRaporu"] ? EChartsPieVM.fromJS(_data["sehirRaporu"]) : undefined;
            this.yatirimCinsiRaporu = _data["yatirimCinsiRaporu"] ? EChartsPieVM.fromJS(_data["yatirimCinsiRaporu"]) : undefined;
            this.sektorRaporu = _data["sektorRaporu"] ? EChartsPieVM.fromJS(_data["sektorRaporu"]) : undefined;
            this.onayBekleyenBS = _data["onayBekleyenBS"];
            this.degerlendirilenBS = _data["degerlendirilenBS"];
            this.degerlendirmeBekleyenBS = _data["degerlendirmeBekleyenBS"];
            this.girisiDevamEdenBS = _data["girisiDevamEdenBS"];
            this.degerlendirilmeyeGonderilmeyenBS = _data["degerlendirilmeyeGonderilmeyenBS"];
        }
    };
    DashboardVM.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DashboardVM();
        result.init(data);
        return result;
    };
    DashboardVM.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sehirRaporu"] = this.sehirRaporu ? this.sehirRaporu.toJSON() : undefined;
        data["yatirimCinsiRaporu"] = this.yatirimCinsiRaporu ? this.yatirimCinsiRaporu.toJSON() : undefined;
        data["sektorRaporu"] = this.sektorRaporu ? this.sektorRaporu.toJSON() : undefined;
        data["onayBekleyenBS"] = this.onayBekleyenBS;
        data["degerlendirilenBS"] = this.degerlendirilenBS;
        data["degerlendirmeBekleyenBS"] = this.degerlendirmeBekleyenBS;
        data["girisiDevamEdenBS"] = this.girisiDevamEdenBS;
        data["degerlendirilmeyeGonderilmeyenBS"] = this.degerlendirilmeyeGonderilmeyenBS;
        return data;
    };
    DashboardVM.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DashboardVM();
        result.init(json);
        return result;
    };
    return DashboardVM;
}());
export { DashboardVM };
var EChartsPieVM = /** @class */ (function () {
    function EChartsPieVM(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EChartsPieVM.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"] ? Title.fromJS(_data["title"]) : undefined;
            this.xAxis = _data["xAxis"] ? Axis.fromJS(_data["xAxis"]) : undefined;
            this.yAxis = _data["yAxis"] ? Axis.fromJS(_data["yAxis"]) : undefined;
            if (Array.isArray(_data["series"])) {
                this.series = [];
                for (var _i = 0, _a = _data["series"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.series.push(Series.fromJS(item));
                }
            }
            this.tooltip = _data["tooltip"] ? Tooltip.fromJS(_data["tooltip"]) : undefined;
            this.legend = _data["legend"] ? Legend.fromJS(_data["legend"]) : undefined;
            this.toolbox = _data["toolbox"];
        }
    };
    EChartsPieVM.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EChartsPieVM();
        result.init(data);
        return result;
    };
    EChartsPieVM.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title ? this.title.toJSON() : undefined;
        data["xAxis"] = this.xAxis ? this.xAxis.toJSON() : undefined;
        data["yAxis"] = this.yAxis ? this.yAxis.toJSON() : undefined;
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (var _i = 0, _a = this.series; _i < _a.length; _i++) {
                var item = _a[_i];
                data["series"].push(item.toJSON());
            }
        }
        data["tooltip"] = this.tooltip ? this.tooltip.toJSON() : undefined;
        data["legend"] = this.legend ? this.legend.toJSON() : undefined;
        data["toolbox"] = this.toolbox;
        return data;
    };
    EChartsPieVM.prototype.clone = function () {
        var json = this.toJSON();
        var result = new EChartsPieVM();
        result.init(json);
        return result;
    };
    return EChartsPieVM;
}());
export { EChartsPieVM };
var Title = /** @class */ (function () {
    function Title(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Title.prototype.init = function (_data) {
        if (_data) {
            this.text = _data["text"];
            this.subtext = _data["subtext"];
            this.x = _data["x"];
        }
    };
    Title.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Title();
        result.init(data);
        return result;
    };
    Title.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["subtext"] = this.subtext;
        data["x"] = this.x;
        return data;
    };
    Title.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Title();
        result.init(json);
        return result;
    };
    return Title;
}());
export { Title };
var Axis = /** @class */ (function () {
    function Axis(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Axis.prototype.init = function (_data) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [];
                for (var _i = 0, _a = _data["categories"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.categories.push(item);
                }
            }
            this.axisLabel = _data["axisLabel"];
            this.axisLine = _data["axisLine"];
            this.axisTick = _data["axisTick"];
        }
    };
    Axis.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Axis();
        result.init(data);
        return result;
    };
    Axis.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (var _i = 0, _a = this.categories; _i < _a.length; _i++) {
                var item = _a[_i];
                data["categories"].push(item);
            }
        }
        data["axisLabel"] = this.axisLabel;
        data["axisLine"] = this.axisLine;
        data["axisTick"] = this.axisTick;
        return data;
    };
    Axis.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Axis();
        result.init(json);
        return result;
    };
    return Axis;
}());
export { Axis };
var Series = /** @class */ (function () {
    function Series(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Series.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (var _i = 0, _a = _data["data"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.data.push(SeriesData.fromJS(item));
                }
            }
            this.itemStyle = _data["itemStyle"];
            this.radius = _data["radius"];
            if (Array.isArray(_data["center"])) {
                this.center = [];
                for (var _b = 0, _c = _data["center"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.center.push(item);
                }
            }
        }
    };
    Series.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Series();
        result.init(data);
        return result;
    };
    Series.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (var _i = 0, _a = this.data; _i < _a.length; _i++) {
                var item = _a[_i];
                data["data"].push(item.toJSON());
            }
        }
        data["itemStyle"] = this.itemStyle;
        data["radius"] = this.radius;
        if (Array.isArray(this.center)) {
            data["center"] = [];
            for (var _b = 0, _c = this.center; _b < _c.length; _b++) {
                var item = _c[_b];
                data["center"].push(item);
            }
        }
        return data;
    };
    Series.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Series();
        result.init(json);
        return result;
    };
    return Series;
}());
export { Series };
var Tooltip = /** @class */ (function () {
    function Tooltip(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Tooltip.prototype.init = function (_data) {
        if (_data) {
            this.trigger = _data["trigger"];
            this.formatter = _data["formatter"];
        }
    };
    Tooltip.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Tooltip();
        result.init(data);
        return result;
    };
    Tooltip.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["trigger"] = this.trigger;
        data["formatter"] = this.formatter;
        return data;
    };
    Tooltip.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Tooltip();
        result.init(json);
        return result;
    };
    return Tooltip;
}());
export { Tooltip };
var Legend = /** @class */ (function () {
    function Legend(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Legend.prototype.init = function (_data) {
        if (_data) {
            this.right = _data["right"];
            this.left = _data["left"];
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (var _i = 0, _a = _data["data"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.data.push(item);
                }
            }
            this.orient = _data["orient"];
            if (_data["selected"]) {
                this.selected = {};
                for (var key in _data["selected"]) {
                    if (_data["selected"].hasOwnProperty(key))
                        this.selected[key] = _data["selected"][key];
                }
            }
            this.type = _data["type"];
        }
    };
    Legend.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Legend();
        result.init(data);
        return result;
    };
    Legend.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["right"] = this.right;
        data["left"] = this.left;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (var _i = 0, _a = this.data; _i < _a.length; _i++) {
                var item = _a[_i];
                data["data"].push(item);
            }
        }
        data["orient"] = this.orient;
        if (this.selected) {
            data["selected"] = {};
            for (var key in this.selected) {
                if (this.selected.hasOwnProperty(key))
                    data["selected"][key] = this.selected[key];
            }
        }
        data["type"] = this.type;
        return data;
    };
    Legend.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Legend();
        result.init(json);
        return result;
    };
    return Legend;
}());
export { Legend };
var SeriesData = /** @class */ (function () {
    function SeriesData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SeriesData.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    };
    SeriesData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SeriesData();
        result.init(data);
        return result;
    };
    SeriesData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    SeriesData.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SeriesData();
        result.init(json);
        return result;
    };
    return SeriesData;
}());
export { SeriesData };
var Role = /** @class */ (function () {
    function Role(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Role.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.concurrencyStamp = _data["concurrencyStamp"];
        }
    };
    Role.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Role();
        result.init(data);
        return result;
    };
    Role.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["concurrencyStamp"] = this.concurrencyStamp;
        return data;
    };
    Role.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Role();
        result.init(json);
        return result;
    };
    return Role;
}());
export { Role };
var Setting = /** @class */ (function () {
    function Setting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Setting.prototype.init = function (_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? moment.parseZone(_data["createdOn"].toString()) : undefined;
            this.updatedOn = _data["updatedOn"] ? moment.parseZone(_data["updatedOn"].toString()) : undefined;
        }
    };
    Setting.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Setting();
        result.init(data);
        return result;
    };
    Setting.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString(true) : undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString(true) : undefined;
        return data;
    };
    Setting.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Setting();
        result.init(json);
        return result;
    };
    return Setting;
}());
export { Setting };
var SwaggerException = /** @class */ (function (_super) {
    __extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
export { SwaggerException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}



//////////////////
// WEBPACK FOOTER
// ./src/shared/services/service-proxies.ts
// module id = 131
// module chunks = 0